<h2 mat-dialog-title class="av-section-title">{{ 'backoffice.billing.credit_notes.dialog_title' | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.billing.credit_notes.dialog_hint' | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="credit-note-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.billing.credit_notes.invoice' | translate }}</dt>
      <dd class="m-0 text-end av-source">{{ data.invoiceReference }}</dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.billing.credit_notes.remainder_label' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="credit-note-remainder">
        {{ data.creditableRemainder }} {{ data.currency || '' }}
      </dd>
    </div>
  </dl>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="credit-note-amount">
      <span class="av-meta">{{ 'backoffice.billing.credit_notes.amount_label' | translate }}</span>
      <input
        id="credit-note-amount"
        type="number"
        step="0.01"
        min="0"
        class="av-field"
        [attr.max]="data.creditableRemainder"
        formControlName="amount"
        data-testid="credit-note-amount-input"
      />
    </label>

    @if (!isAmountValid()) {
      <p class="av-meta m-0" data-testid="credit-note-amount-invalid">
        {{ 'backoffice.billing.credit_notes.amount_invalid' | translate }}
      </p>
    }

    <label class="d-flex flex-column gap-1" for="credit-note-reason">
      <span class="av-meta">{{ 'backoffice.billing.credit_notes.reason_label' | translate }}</span>
      <select id="credit-note-reason" class="av-field" formControlName="reason">
        @for (reason of reasonOptions; track reason) {
          <option [value]="reason">{{ reasonLabels[reason] | translate }}</option>
        }
      </select>
    </label>

    @if (data.isPaid) {
      <label class="d-flex align-items-center gap-2" for="credit-note-refund">
        <input
          id="credit-note-refund"
          type="checkbox"
          formControlName="refund"
          data-testid="credit-note-refund-toggle"
        />
        <span>{{ 'backoffice.billing.credit_notes.refund_label' | translate }}</span>
      </label>
    } @else {
      <p class="av-meta m-0" data-testid="credit-note-refund-unavailable">{{ 'backoffice.billing.credit_notes.refund_hint' | translate }}</p>
    }

    <label class="d-flex flex-column gap-1" for="credit-note-note">
      <span class="av-meta">{{ 'backoffice.billing.credit_notes.note_label' | translate }}</span>
      <textarea
        id="credit-note-note"
        class="av-field"
        rows="3"
        [attr.maxlength]="noteMax"
        formControlName="note"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid || !isAmountValid()"
    (click)="confirm()"
    data-testid="credit-note-submit"
  >
    {{ 'backoffice.billing.credit_notes.submit' | translate }}
  </button>
</mat-dialog-actions>
